import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  margin-right: auto;
  margin-left: auto;

  @media (max-width: 767px) {
    max-width: 560px;
    padding: 0px;
    margin: 0px;
  }

  @media (max-width: 1025px) {
    max-width: 100%;
    padding: 24px 0px;
    margin: 0px;
  }

  @media (min-width: 1200px) {
    max-width: 1140px;
  }

  @media (min-width: 1400px) {
    max-width: 1320px;
  }
`;
